export const environment = {
  production: true,
  apiurl: 'https://hvarest.omnicms3.nl:9502/api/v1/',
  mock: false,
  config: {
    product: "Mijn UvA-Pas",
    customer_fullname: "Universiteit van Amsterdam",
    customer_shortname: "UVA",
    url: "https://omnicard.nl/product/omnipas",
    phone: "+31 20 525 1403",
    email: "servicedesk-fs@uva.nl",
    MFAemail: false,
    MFAsms: false,
    logintype : "database",
    autologin: false,
    username: "",
    password: "",
    samlConfig: {},
    surfConfig: {},
    adfsConfig: {},
    psptype: "worldlinedirect",
    ingenico: {
      url: "https://secure.ogone.com/ncol/test/orderstandard.asp",
      orderid: "CARD C.4201.0004 ",
      pspid: "OmnicardMBOtest",
      sha_in_key: "Vh5G9kFd+mZoiGHns1@gQEEz",
      sha_out_key: "wLB0d96md@+MRKA++@l*@Bx+",
      currency: "EUR",
      bgcolor: "#F3F3F3",
      txtcolor: "#004C93",
      tblbgcolor: "#FFFFFF",
      tbltxtcolor: "#666666",
      buttonbgcolor: "#004C93",
      buttontxtcolor: "#FFFFFF",
      fonttype: "Verdana",
      pm: "iDEAL",
      homeurl: "https://www.mijnuvapas.nl/test/payment",
      accepturl: "https://www.mijnuvapas.nl/test/payment/success",
      declineurl: "https://www.mijnuvapas.nl/test/payment/decline",
      exceptionurl: "https://www.mijnuvapas.nl/test/payment/fail",
      cancelurl: "https://www.mijnuvapas.nl/test/payment/cancel"
    },
    postcode: {
      url: "https://api.postcode.eu/nl/v1/addresses/postcode/",
      key: "s4k7iIx6OiEwbZypep1zZWBeZiYJOpkyDyvzPUCDjZt",
      secret: "AksxuszQHWXjBf9G604vmUhyNq2nOSxKohtns6rnhJSKqXT3uk"
    },
//    cardprices: { "Student": 1500, "Employee": 1000, "External employee": 1000, "default": 1250 },
    cardprices: { "Student": 1, "Employee": 0, "External employee": 0, "default": 1500 },
    languages: [
      {
        id: 1,
        LanguageCode: "nl",
        LanguageName: "Nederlands",
        Card: "pas"
      },
      {
        id: 2,
        LanguageCode: "en",
        LanguageName: "English",
        Card: "pass"
      }

    ],
    nameoncardformats: [
      { id: 1, format: "<<Initials>> <<MiddleName>> <<LastName>>" },
      { id: 2, format: "<<FirstName>> <<MiddleName>> <<LastName>>" },
      { id: 3, format: "<<LastName>>, <<FirstName>> <<MiddleName>>" }
    ],
    savephotoonserver: false,
    changepublishpermission: false,
    chargingcard: false,
    digitalcard: false,
    uploadphoto: true,
    webcam: true,
    licenseplate: false,
    nameoncard: false,
    cardpreview: true,
    cardaslink: false,
    cardresult: true,
    cardactivate: true,
    cardblock: true,
    carddeblock: false,
    cardrequest: true,
    logoutbutton: false,
    requestnewpassword: true,
    publishPermission: false,
    scrollButtons: true,
    breadcrumbs: false,
    versioninfooter: false,
    photoResizeToWidth: 480,
    photoMiniatureWidth: 240,
    togglefont: false,
    photorequirements: false,
    firstnameonwelcome: false,
    photoAgreedNotOnFirstPage: true,
    deliveryaddress: false,
    deliveryaddress2: false,
    langimage : false,
    maintainance: false,
    timeout: 180,
  },
  ssl: true
};
